// Create a variable to check if we're in development mode
const isDev = process.env.REACT_APP_API_ENV === 'local' || process.env.REACT_APP_API_ENV === 'dev';
// Define base URLs
const DEV_BASE_URL = 'http://localhost:8000';
const PROD_BASE_URL = 'https://apigcp.snapmydesign.com';

const API_CONFIG = isDev
  ? {
    BASE_URL: `${DEV_BASE_URL}/api/v1`,
    ENDPOINTS: {
      ANALYTICS: {
        GENERATIONS: '/analytics/generations',
        PAID_USERS_GENERATIONS: '/analytics/paid-users-generations',
        SUBSCRIPTIONS: '/analytics/subscriptions',
        ORDERS: '/analytics/orders',
        USERS: '/analytics/users',
        CREDITS: '/analytics/credits'
      },
      CACHE: {
        STATUS: '/dashboard/analytics/cache-status',
        CLEAR: '/dashboard/analytics/cache-clear'
      },
      USER: {
        PROFILE_DETAILS: '/user/profile-details'
      },
      WEAR_CATALOGUE: {
        ACTIVE_MODEL_PRESETS: '/active-wear-catalogue-generator/model-presets',
        ACTIVE_POSE_PRESETS: '/active-wear-catalogue-generator/pose-presets',
        YOGA_MODEL_PRESETS: '/yoga-wear-catalogue-generator/model-presets',
        YOGA_POSE_PRESETS: '/yoga-wear-catalogue-generator/pose-presets',
        ADMIN_MODELS: '/admin/wear-catalogue/models',
        ADMIN_POSES: '/admin/wear-catalogue/poses',
        UPLOAD: '/wear-catalogue-generator/upload',
        GENERATE: '/wear-catalogue-generator/generate'
      }
    }
  }
  : {
    BASE_URL: `${PROD_BASE_URL}/api/v1`,
    ENDPOINTS: {
      ANALYTICS: {
        GENERATIONS: '/analytics/generations',
        PAID_USERS_GENERATIONS: '/analytics/paid-users-generations',
        SUBSCRIPTIONS: '/analytics/subscriptions',
        ORDERS: '/analytics/orders',
        USERS: '/analytics/users',
        CREDITS: '/analytics/credits'
      },
      CACHE: {
        STATUS: '/dashboard/analytics/cache-status',
        CLEAR: '/dashboard/analytics/cache-clear'
      },
      USER: {
        PROFILE_DETAILS: '/user/profile-details'
      },
      WEAR_CATALOGUE: {
        ACTIVE_MODEL_PRESETS: '/active-wear-catalogue-generator/model-presets',
        ACTIVE_POSE_PRESETS: '/active-wear-catalogue-generator/pose-presets',
        YOGA_MODEL_PRESETS: '/yoga-wear-catalogue-generator/model-presets',
        YOGA_POSE_PRESETS: '/yoga-wear-catalogue-generator/pose-presets',
        ADMIN_MODELS: '/admin/wear-catalogue/models',
        ADMIN_POSES: '/admin/wear-catalogue/poses',
        UPLOAD: '/wear-catalogue-generator/upload',
        GENERATE: '/wear-catalogue-generator/generate'
      }
    }
  };

export default API_CONFIG; 